import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'aftp-virtual-scroll-preloader',
  templateUrl: './virtual-scroll-preloader.component.html',
  styleUrls: ['./virtual-scroll-preloader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VirtualScrollPreloaderComponent {}
